import { render, staticRenderFns } from "./accoDashboard.vue?vue&type=template&id=130e2fd3&scoped=true"
import script from "./accoDashboard.vue?vue&type=script&lang=js"
export * from "./accoDashboard.vue?vue&type=script&lang=js"
import style0 from "./accoDashboard.vue?vue&type=style&index=0&id=130e2fd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e2fd3",
  null
  
)

export default component.exports